import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { PauseCircle, PlayCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { DoNotContactDialog } from './DoNotContactDialog';
import { API, getAuthHeaders } from '../../utils/admin-helpers';

export const PromoPauseBanner = () => {
  const [state, setState] = useState(null);
  const [saving, setSaving] = useState(false);
  const url = `${API}/api/admin/promo-email-pause`;

  useEffect(() => {
    axios.get(url, { headers: getAuthHeaders() }).then((r) => setState(r.data)).catch(() => {});
  }, [url]);

  const toggle = async () => {
    const resume = state.paused;
    if (resume && !window.confirm('Resume promotional emails? Only emails scheduled after now will send; the held backlog stays paused.')) return;
    setSaving(true);
    try {
      const r = await axios.put(url, { paused: !resume }, { headers: getAuthHeaders() });
      setState(r.data);
      toast.success(r.data.paused ? 'Promotional emails paused' : 'Promotional emails resumed');
    } catch { toast.error('Could not update setting'); }
    setSaving(false);
  };

  if (!state) return null;
  const Icon = state.paused ? PauseCircle : PlayCircle;
  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-3 mb-6 px-4 py-3 rounded-lg border ${state.paused ? 'bg-amber-500/10 border-amber-500/40' : 'bg-emerald-500/10 border-emerald-500/40'}`}
      data-testid="promo-pause-banner"
    >
      <div className="flex items-center gap-2 text-sm text-slate-200">
        <Icon className={`h-5 w-5 ${state.paused ? 'text-amber-400' : 'text-emerald-400'}`} />
        <span data-testid="promo-pause-status">
          Promotional email automation: <strong>{state.paused ? 'PAUSED' : 'ACTIVE'}</strong>
        </span>
        <span className="text-slate-400 hidden sm:inline">· Quiz nurture, inquiry and assessment sequences. Password resets and notifications are not affected.</span>
      </div>
      <div className="flex gap-2">
        <DoNotContactDialog />
        <Button size="sm" variant="outline" disabled={saving} onClick={toggle} className="bg-transparent text-white border-white/20" data-testid="promo-pause-toggle-btn">
          {state.paused ? 'Resume' : 'Pause'}
        </Button>
      </div>
    </div>
  );
};
